import DonationForm from "./DonationForm";

export default class FormValidate {
    formsToValidate: NodeList;
    form: HTMLFormElement;
    donationForm: typeof DonationForm;

    constructor() {
        this.donationForm = DonationForm;
        this.formsToValidate = document.querySelectorAll('form[data-val-validate]');
    }

    init() {
        const _this = this;

        if (this.formsToValidate.length > 0) {
            Array.prototype.forEach.call(this.formsToValidate, form => {
                this.form = form;
                let requiredInputs = form.querySelectorAll('[data-val-required]');
                const typeOfDonationInput: HTMLInputElement = form.querySelector('[name="donationType"]');
                const formContainer = form.closest('.acc-donation-form-container');
                const targetid = formContainer.id;
                const donationTypeValue = typeOfDonationInput.value;
                
               
                if (requiredInputs.length > 0) {
                    const submitBtns = form.querySelectorAll('[data-val-submit]');

                    if (submitBtns.length > 0) {

                        Array.prototype.forEach.call(submitBtns, submitBtn => {
                           
                            submitBtn.addEventListener('click', () => {

                                let inputsToValidate = [];
                                var formtoValidate = submitBtn.closest('form');
                                requiredInputs = formtoValidate.querySelectorAll('[data-val-required]');
                                Array.prototype.forEach.call(requiredInputs, input => {
                                    if (this.isVisible(input)) inputsToValidate.push(input);
                                });
                                if (this.validateForm(inputsToValidate, formtoValidate)) {
                                    //check direct debit errors and show confDetails
                                    if (submitBtn.classList.contains("reviewDetails")) {

                                        var txtDdDateError = formtoValidate.querySelector('#txtDdDateError');

                                        if (txtDdDateError) {
                                            const PaymtErrorstyle = getComputedStyle(txtDdDateError);
                                            if (PaymtErrorstyle.display !== 'none') {
                                                const PaymtErrorScroll = formtoValidate.querySelector('#firstPaymentDay').getBoundingClientRect().top;

                                                let layoutOffset = 30;
                                                window.scrollTo({
                                                    top: PaymtErrorScroll + window.pageYOffset - layoutOffset,
                                                    left: 0,
                                                    behavior: 'smooth'
                                                });
                                            }
                                            else {
                                                formtoValidate.querySelector('#confDetails').classList.remove('is-d-none');
                                            }
                                        }
                                        else {
                                            formtoValidate.querySelector('#confDetails').classList.remove('is-d-none');
                                        }
                                    }
                                    else if (submitBtn.classList.contains("complete")) {
                                        var recapchaError = formtoValidate.getElementsByClassName('g-recaptcha-error');
                                        var grecaptcha = window.grecaptcha;
                                        //var recapchaResponse = grecaptcha.getResponse();

                                        var valgrecaptcha = formtoValidate.getElementsByClassName('g-recaptcha-response');


                                        if (valgrecaptcha && valgrecaptcha.length > 0) {
                                            var recapchaResponse = valgrecaptcha[0].value;

                                            if (recapchaResponse != "") {
                                                var recapchaTarget = recapchaError[0].querySelector('strong')
                                                recapchaTarget.innerHTML = '';

                                            }
                                            else {
                                                var recapchaTarget = recapchaError[0].querySelector('strong')
                                                recapchaTarget.innerHTML = 'Verification failed, please try again';
                                              
                                                grecaptcha.reset();
                                                submitBtn.classList.remove("wait");

                                                var submitClass = submitBtn.classList;
                                                submitClass.remove("wait-on-submit");
                                                return;
                                            }
                                        }
                                       
                                        this.donationForm.setDirectDebitFinalStep(formtoValidate);
                                    }
                                    else if (submitBtn.classList.contains("regular-card")) {
                                        if (recapchaError != null) {
                                            var recapchaTarget = recapchaError[0].querySelector('strong')
                                            recapchaTarget.innerHTML = '';
                                        }
                                        else {
                                            recapchaTarget.innerHTML = 'Verification failed, please try again';
                                            return;
                                        }
                                        this.donationForm.submitForPayment(formtoValidate);
                                    }
                                    else {
                                        //console.log(this.donationForm.formStep + 1, 'next step')
                                        //console.log(donationTypeValue, 'donationTypeValue')
                                        //console.log('formstep:', this.donationForm.formStep);
                                        this.donationForm.setFormStep(targetid, this.donationForm.formStep + 1, donationTypeValue);
                                    }
                                }
                                else {
                                    let addressFinderContentWrappers = form.querySelectorAll('.address-lookup-wrapper .reveal-content');

                                    Array.prototype.forEach.call(addressFinderContentWrappers, addressFinderContent => {
                                        let inputInvalid = addressFinderContent.querySelectorAll('input.invalid');
                                        if (inputInvalid.length) {
                                            addressFinderContent.classList.remove('hidden-accessible');
                                        }
                                    });


                                }
                            });

                        });
                    }

                    Array.prototype.forEach.call(requiredInputs, input => {
                        if (input.dataset.valRequired.length > 0) {
                          
                            const errorWrapper = document.createElement('span');
                            errorWrapper.classList.add('validate-error');
                            errorWrapper.classList.add('is-d-none');
                            errorWrapper.setAttribute('aria-hidden', 'true');
                            input.closest('.input-wrapper') !== null ?
                                input.closest('.input-wrapper').appendChild(errorWrapper) :
                                input.closest('.select-wrapper').appendChild(errorWrapper);

                            if (input.type === 'radio' || input.type === 'checkbox' || input.tagName === 'SELECT') {
                                input.addEventListener('change', () => {
                                    _this.validateInput(input);
                                    console.log('change event')
                                });
                            } else {
                                input.addEventListener('input', () => {
                                    _this.validateInput(input);
                                    console.log('input value change')
                                });
                            }
                        }
                    });
                }
            });
        }
    }

    validateInput(el): boolean {
        const values = {
            nodeType: el.tagName,
            value: el.value,
            name: el.dataset.valRequired[0].toUpperCase() + el.dataset.valRequired.slice(1),
            type: el.type,
            minNumber: el.dataset.valMinNum,
            maxNumber: el.dataset.valMaxNum,
            minLength: el.dataset.valMinLength,
            maxLength: el.dataset.valMaxLength,
            pattern: el.dataset.valPattern,
            passConfirm: el.dataset.valConfirm,
            errorMessage: el.dataset.valError
        };

        const messageList = {
            required: values.name,
            minLength: `Please enter at least ${values.minLength} characters`,
            maxLength: `Please enter a maximum of ${values.maxLength} characters`,
            password: values.errorMessage ? values.errorMessage : 'Please enter a valid password',
            passConfirm: 'Passwords must match',
            numberRange: `Please enter a number between ${values.minNumber} and ${values.maxNumber}`,
            email: 'Please enter a valid email address',
            phone: 'Please enter a valid telephone number',
            date: 'A valid date is required'
        };

        let errorMessage = null;
        let isValid = true;

        switch (true) {
            case values.type === 'text' || values.nodeType === 'TEXTAREA' || values.nodeType === 'SELECT':
                isValid = this.isNotEmpty(values.value)
                    && this.minLength(values.value, values.minLength)
               
                errorMessage = messageList.required;
                break;
            case values.type === 'email':
                if (this.isNotEmpty(values.value)) {
                    isValid = this.isValidEmail(values.value);
                    errorMessage = messageList.email;
                } else {
                    isValid = false;
                    errorMessage = messageList.required;
                }
                break;
            case values.type === 'password':
                if (this.isNotEmpty(values.value)) {
                    const passWordFields = el.closest('form').querySelectorAll('input[type="password"]');

                    if (values.passConfirm === 'true') {
                        isValid = this.matchStr(passWordFields[0].value, values.value);
                        errorMessage = messageList.passConfirm;
                    } else {
                        if (passWordFields.length > 1 && passWordFields[1].value.length > 0) {
                            if (!this.matchStr(passWordFields[1].value, values.value)) {
                                this.showError(passWordFields[1], messageList.passConfirm);
                            } else {
                                this.hideError(passWordFields[1]);
                            }
                        }
                        isValid = this.isValidPassword(values.value, values.pattern);
                        errorMessage = messageList.password;
                    }
                } else {
                    isValid = false;
                    errorMessage = messageList.required;
                }
                break;
            case values.type === 'tel':
                if (this.isNotEmpty(values.value)) {
                    isValid =
                        this.isValidPhone(values.value) &&
                        this.minLength(values.value, values.minLength) &&
                        this.maxLength(values.value, values.maxLength);
                    errorMessage = messageList.phone;
                } else {
                    isValid = false;
                    errorMessage = messageList.required;
                }
                break;
            case values.type === 'date':
                isValid = this.isValidDate(values.value);
                errorMessage = messageList.date;
                break;
            case values.type === 'number':
                if (this.isNotEmpty(values.value)) {
                    isValid = this.isValidNumRange(values.value, values.minNumber, values.maxNumber);
                    errorMessage = messageList.numberRange;
                } else {
                    isValid = false;
                    errorMessage = messageList.required;
                }
                break;
            case values.type === 'checkbox':
                if (!el.checked) {
                    isValid = false;
                    errorMessage = messageList.required;
                }
                break;
            case values.type === 'radio':
                const radioGroup = el.closest('.input-wrapper');
                const radios = radioGroup.querySelectorAll('input[type="radio"]');

                isValid = false;
                errorMessage = messageList.required;

                Array.prototype.forEach.call(radios, radio => {
                    if (radio.checked) isValid = true;
                });
                break;
        }

        if (!isValid) {
            this.showError(el, errorMessage);
            return false;
        }

        this.hideError(el);
        return true;
    }

    validateForm(inputs, form): boolean {
        let invalidInputs = [];
       
        Array.prototype.forEach.call(inputs, input => {
            if (!this.validateInput(input)) invalidInputs.push(input);
        });
        if (invalidInputs.length < 1) {
            return true;
        } else {
            const firstInputPos = invalidInputs[0].getBoundingClientRect().top;
            let layoutOffset = 30;

            if (document.body.classList.contains("has-no-scroll")) {
                const scrollableContentAreas = form.querySelectorAll('.acc-modal-content');
                const scrollableContent = scrollableContentAreas[this.donationForm.formStep - 1];
                const stepsNav = invalidInputs[0].closest('.donation-form-modal').querySelector('.donation-steps-nav');
                
                let offset = 0;//
                if (stepsNav) {
                    offset = stepsNav.getBoundingClientRect().bottom;
                } else {
                    offset = (invalidInputs[0].closest('.donation-form-modal').getBoundingClientRect().top + 20);
                }

                scrollableContent.scrollTo({
                    top: scrollableContent.scrollTop + (firstInputPos - offset),
                    left: 0,
                    behavior: 'smooth'
                });

            } else {
                window.scrollTo({
                    top: firstInputPos + window.pageYOffset - layoutOffset,
                    left: 0,
                    behavior: 'smooth'
                });
            }
        }
        return false;
    }

    isNotEmpty(value): boolean {
        const strValue = String(value);
        return strValue.length > 0;
    }

    isValidEmail(value): boolean {
        const emailPattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return emailPattern.test(String(value).toLowerCase());
    }

    isValidPhone(value): boolean {
        const phonePattern = /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/g;
        return phonePattern.test(String(value).toLowerCase());
    }

    isValidPassword(value, pattern): boolean {
        if (pattern === undefined) return true;
        const regex = new RegExp(pattern);
        return regex.test(value);
    }

    isValidPostcode(value): boolean {
        const ukPattern = /^[A-Z]{1,2}\d[A-Z\d]? ?\d[A-Z]{2}$/gmi;
        return ukPattern.test(value);
    }

    isValidDate(value): boolean {
        let dateArr;
        let date;
        let isValidDate;

        if (typeof value === 'object') {
            isValidDate = value && !isNaN(value.getTime());
        } else if (value.indexOf('/') !== -1) {
            dateArr = value.split('/');
            date = new Date(dateArr[2], +dateArr[1] - 1, dateArr[0]);
            isValidDate = Boolean(+date) && date.getDate() == dateArr[0];
        } else if (value.indexOf('-') !== -1) {
            dateArr = value.split('-');
            date = new Date(dateArr[0], +dateArr[1] - 1, dateArr[2]);
            isValidDate = Boolean(+date) && date.getDate() == dateArr[2];
        } else {
            return false;
        }
        return isValidDate;
    }

    isValidNumRange(value, min, max): boolean {
        return this.minNumber(value, min) && this.maxNumber(value, max);
    }

    matchStr(password, compare): boolean {
        if (password === compare) {
            return true;
        }
        return false;
    }

    minLength(value, min): boolean {
        if (min === undefined)
            return true;
        return value.length >= min;
    }

    maxLength(value, max): boolean {
        if (max === undefined) return true;
        return value.length <= max;
    }

    minNumber(value, min): boolean {
        if (min === undefined) return true;
        return Number(value) >= min;
    }

    maxNumber(value, max): boolean {
        if (max === undefined) return true;
        return Number(value) <= max;
    }

    showError(el, message): void {
        const messageWrapper = el.closest('.input-wrapper') !== null ?
            el.closest('.input-wrapper').querySelector('.validate-error') :
            el.closest('.select-wrapper').querySelector('.validate-error');
        el.classList.remove('valid');
        el.classList.add('invalid');
        messageWrapper.textContent = message;
        messageWrapper.classList.remove('is-d-none');
    }

    hideError(el): void {
        const messageWrapper = el.closest('.input-wrapper') !== null ?
            el.closest('.input-wrapper').querySelector('.validate-error') :
            el.closest('.select-wrapper').querySelector('.validate-error');
        el.classList.remove('invalid');
        el.classList.add('valid');
        messageWrapper.classList.add('is-d-none');
    }

    isVisible(el) {
        return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length);
    }
}
